export enum CharacterLength {
  MINIMUM_SEARCH_CHARACTER_LENGTH = 3
}
